import React from 'react';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-blue-900 mb-4">What Our Community Says</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">Hear from our students, parents, and alumni about their experiences at Moxie Master Public School</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div className="bg-white rounded-xl shadow-md p-8 flex flex-col gap-6 transition-transform hover:-translate-y-1 hover:shadow-lg">
            <div className="text-5xl text-blue-700 mb-2">“</div>
            <p className="text-gray-700 text-lg leading-relaxed">Moxie Master Public School has provided my child with an exceptional education. The teachers are dedicated, the facilities are outstanding, and the academic standards are world-class. I couldn't be happier with our choice.</p>
            <div className="flex items-center gap-4 mt-4">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-blue-800 to-blue-900 flex items-center justify-center text-white text-base font-medium">
                Parent
              </div>
              <div>
                <h4 className="text-blue-900 font-semibold mb-1">Sarah Johnson</h4>
                <span className="text-gray-500 text-sm">Parent of Grade 8 Student</span>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-md p-8 flex flex-col gap-6 transition-transform hover:-translate-y-1 hover:shadow-lg">
            <div className="text-5xl text-blue-700 mb-2">“</div>
            <p className="text-gray-700 text-lg leading-relaxed">The supportive environment and dedicated staff at Moxie Master have helped me grow academically and personally. I am proud to be a part of this amazing school community.</p>
            <div className="flex items-center gap-4 mt-4">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-blue-800 to-blue-900 flex items-center justify-center text-white text-base font-medium">
                Student
              </div>
              <div>
                <h4 className="text-blue-900 font-semibold mb-1">Amit Patel</h4>
                <span className="text-gray-500 text-sm">Grade 12 Student</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 